import { Component, OnInit } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'
import { CalenderConfigService } from '../../../../shared/services/calender-config.service'

@Component({
  selector: 'app-customer-req-date-dialog',
  standalone: false,
  templateUrl: './customer-req-date-dialog.component.html',
  styleUrl: './customer-req-date-dialog.component.scss'
})
export class CustomerReqDateDialogComponent {

  constructor(private launchDialogService: LaunchDialogService,
    private calenderConfigService: CalenderConfigService,
  ) {}

  selectedCRD: any = '';
  minDate = new Date();
  filterWeekend = this.calenderConfigService.isFilterWeekend();
  showErrorTxt: boolean = false;

  dateChange(event) {
    this.selectedCRD =
      event.getFullYear() +
      '/' +
      this.getMonth(event) +
      '/' +
      event.getDate().toString().padStart(2, '0');
    
    this.showErrorTxt = false;
  }

  getMonth(event) {
    if ((Number(event.getMonth()) + 1) / 10 < 1) {
      return (Number(event.getMonth()) + 1).toString().padStart(2, '0')
    }
    if ((Number(event.getMonth()) + 1) / 10 >= 1) {
      return Number(event.getMonth()) + 1
    }
  }

  closeModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      reason: reason,
      type: VS_LAUNCH_CALLER.CRD_INPUT_MODAL,
      data: this.selectedCRD
    }

    if(reason == 'crd-selected'){
      if(!this.selectedCRD){
        this.showErrorTxt = true;
      } else{
        this.showErrorTxt = false;
        this.launchDialogService.closeDialog(dialogResponse)
      }
    } else{
      this.launchDialogService.closeDialog(dialogResponse)
    }    
  }

}
